/* jshint ignore:start */

var CommonManager = (function($) {
    // console.log("llamada a config idioma");
    var instance;

    var YOUTUBE_TEMPLATE = '<iframe width="[*WIDTH*]" height="[*HEIGHT*]" src="https://www.youtube.com/embed/[*VIDEO_CODE*]?rel=0&amp;autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>';

    var VIMEO_TEMPLATE = '<iframe width="[*WIDTH*]" height="[*HEIGHT*]" src="https://player.vimeo.com/video/[*VIDEO_CODE*]?autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>';

    function init() {


        return {

            init: function() {

                var $linksDisables = $('.js-disabled-link');
                if ($linksDisables.length) {
                    $linksDisables.on('click', function (e) {
                        e.preventDefault(); 
                    });
                }

                var $videosShow = $('.js-video');
                if ($videosShow.length) {

                    $videosShow.modaal({
                        type: 'video'
                    });
                }

                var $btnSearchInPage = $('.js-search-page-btn');
                if ($btnSearchInPage.length) {
                    $btnSearchInPage.on('click', function (e) {
                        e.preventDefault();
                        $('.js-search-page').submit();
                    });
                }



            }
        };
    }


    return {

        getInstance: function(){

            if (!instance){
                instance = init();
            }

            return instance;
        }
    };
})(jQuery);
/* jshint ignore:end */

